var exports = {
  "kL": "x31de4314--847c4f--container",
  "Sl": "x31de4314--847c4f--image",
  "P": "x31de4314--847c4f--tour",
  "VY": "x31de4314--847c4f--info-block",
  "Zp": "x31de4314--847c4f--layout",
  "gf": "x31de4314--847c4f--layout-params",
  "bE": "x31de4314--847c4f--layout-price",
  "M3": "x31de4314--847c4f--contacts",
  "cL": "x31de4314--847c4f--builder",
  "zq": "x31de4314--847c4f--contact-buttons",
};

module.exports = exports;
